import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { RestService, ExtRestConfig, ModelMetaService } from '../../common';
var ApiTableService = /** @class */ (function () {
    function ApiTableService(conf, modelMetaService, rest) {
        this.conf = conf;
        this.modelMetaService = modelMetaService;
        this.rest = rest;
    }
    /**Get the model */
    ApiTableService.prototype.getModel = function (model, projecion) {
        return this.modelMetaService.getModel(model, projecion);
    }; // getModel()
    ApiTableService.prototype.getTableData = function (meta, pageAndSort) {
        var params = new HttpParams();
        params = params.append('projection', 'dataTable');
        if (pageAndSort) {
            params = params.append('page', pageAndSort.page.toString());
            params = params.append('size', pageAndSort.size.toString());
        }
        return this.rest.http.get(this.conf.basePath + meta.url, { params: params });
    }; // getTableData()
    ApiTableService.prototype.getItem = function (url) {
        return this.rest.http.get(url);
    };
    ApiTableService = tslib_1.__decorate([
        Injectable(),
        tslib_1.__metadata("design:paramtypes", [ExtRestConfig,
            ModelMetaService,
            RestService])
    ], ApiTableService);
    return ApiTableService;
}()); // class
export { ApiTableService };
//# sourceMappingURL=api-table.service.js.map